import React from 'react';
export default function HomePage() {
  return <h1>Welcome to HorseMarket 🐎</h1>;
}